export const CountryIsoNamesLanguagePack = [
	// { name: 'Austria', 'alpha-2': 'AT', languageCode: 'AT', language: 'German' },
	// { name: 'Belgium', 'alpha-2': 'BE', languageCode: 'BE', language: 'Dutch' },
	{ name: 'Bulgaria', 'alpha-2': 'BG', languageCode: 'BG', language: 'Bulgarian' },
	// { name: 'Croatia', 'alpha-2': 'HR', languageCode: 'HR', language: 'Croatian' },
	// { name: 'Cyprus', 'alpha-2': 'CY', languageCode: 'CY', language: 'Greek' },
	{ name: 'Czech Republic', 'alpha-2': 'CZ', languageCode: 'CS', language: 'Czech' },
	{ name: 'Denmark', 'alpha-2': 'DK', languageCode: 'DA', language: 'Danish' },
	{ name: 'Estonia', 'alpha-2': 'EE', languageCode: 'ET', language: 'Estonian' },
	{ name: 'Finland', 'alpha-2': 'FI', languageCode: 'FI', language: 'Finnish' },
	{ name: 'France', 'alpha-2': 'FR', languageCode: 'FR', language: 'French' },
	{ name: 'Germany', 'alpha-2': 'DE', languageCode: 'DE', language: 'German' },
	{ name: 'Greece', 'alpha-2': 'GR', languageCode: 'EL', language: 'Greek' },
	{ name: 'Hungary', 'alpha-2': 'HU', languageCode: 'HU', language: 'Hungarian' },
	// { name: 'Ireland', 'alpha-2': 'IE', languageCode: 'IE', language: 'English' },
	{ name: 'Italy', 'alpha-2': 'IT', languageCode: 'IT', language: 'Italian' },
	{ name: 'Latvia', 'alpha-2': 'LV', languageCode: 'LV', language: 'Latvian' },
	{ name: 'Lithuania', 'alpha-2': 'LT', languageCode: 'LT', language: 'Lithuanian' },
	// { name: 'Luxembourg', 'alpha-2': 'LU', languageCode: 'LU', language: 'German' },
	// { name: 'Malta', 'alpha-2': 'MT', languageCode: 'MT', language: 'Maltese' },
	{ name: 'Netherlands', 'alpha-2': 'NL', languageCode: 'NL', language: 'Dutch' },
	{ name: 'Norway', 'alpha-2': 'NO', languageCode: 'NB', language: 'Norwegian' },
	{ name: 'Poland', 'alpha-2': 'PL', languageCode: 'PL', language: 'Polish' },
	{ name: 'Portugal', 'alpha-2': 'PT', languageCode: 'PT', language: 'Portuguese' },
	{ name: 'Romania', 'alpha-2': 'RO', languageCode: 'RO', language: 'Romanian' },
	{ name: 'Slovakia', 'alpha-2': 'SK', languageCode: 'SK', language: 'Slovak' },
	{ name: 'Slovenia', 'alpha-2': 'SI', languageCode: 'SL', language: 'Slovenian' },
	{ name: 'Spain', 'alpha-2': 'ES', languageCode: 'ES', language: 'Spanish' },
	{ name: 'Sweden', 'alpha-2': 'SE', languageCode: 'SV', language: 'Swedish' },
	// { name: 'Switzerland', 'alpha-2': 'CH', languageCode: 'CH', language: 'Swiss German' },
	{ name: 'United Kingdom', 'alpha-2': 'GB', languageCode: 'EN', language: 'English' },
]
